import Nudge from '../Models/Nudge';
import nudges from '../Static/Nudges/nudges.json';
import { getPfmType } from './storageUtils';

export default function getNudges(screen?: string): Nudge[] {
  const nudgeListJson = nudges.filter(
    (nudge) =>
      'profile' in nudge &&
      nudge.profile === getPfmType() &&
      (screen === undefined || nudge.screen === screen)
  );
  return nudgeListJson.map((nudge) => {
    const icon = 'icon' in nudge ? (nudge.icon as string) : '';
    const ctaText = 'ctaText' in nudge ? (nudge.ctaText as string) : '';
    const ctaLink = 'ctaLink' in nudge ? (nudge.ctaLink as string) : '';
    const nudgeId = 'nudgeId' in nudge ? (nudge.nudgeId as string) : '';
    
    return new Nudge(nudge.label as string, icon, ctaText, ctaLink, nudgeId);
  });
}
